// extracted by mini-css-extract-plugin
export default {"button":"HangUpButton_button__EOAGb","subtitle":"HangUpButton_subtitle__LtUfg"};